import { ReactNode, useEffect, useRef } from "react";
import Reveal from "reveal.js";
import Highlight from "reveal.js/plugin/highlight/highlight";
import RevealNotes from "reveal.js/plugin/notes/notes";
import "reveal.js/dist/reveal.css";
import "reveal.js/plugin/highlight/monokai.css";
import "./theme/tec.css";
import { useParams } from "react-router-dom";
import S00P00 from "../../assets/decks/S00P00";
import S01P00 from "../../assets/decks/S01P00";
import S01P02 from "../../assets/decks/S01P02";
import S02P01 from "../../assets/decks/S02P01";
import S02P02 from "../../assets/decks/S02P02";
import S03P01 from "../../assets/decks/S03P01";
import S03P02 from "../../assets/decks/S03P02";
import S04P01 from "../../assets/decks/S04P01";
import S05P01 from "../../assets/decks/S05P01";
import S05P02 from "../../assets/decks/S05P02";
import S06P01 from "../../assets/decks/S06P01";
import S07P01 from "../../assets/decks/S07P01";
import S08P01 from "../../assets/decks/S08P01";
import S09P01 from "../../assets/decks/S09P01";
import S11P01 from "../../assets/decks/S11P01";
import S12P01 from "../../assets/decks/S12P01";
import S14P01 from "../../assets/decks/S14P01";
import S15P01 from "../../assets/decks/S15P01";
import S16P01 from "../../assets/decks/S16P01";

export default function SlideDeck() {
  const { deckId } = useParams();
  const deckDivRef = useRef<HTMLDivElement>(null); // reference to deck container div
  const deckRef = useRef<Reveal.Api | null>(null); // reference to deck reveal instance

  let ComponentToRender: ReactNode = <></>;
  switch (deckId) {
    case "S00P00":
      ComponentToRender = <S00P00 reveal={deckRef.current} />;
      break;
    case "S01P00":
      ComponentToRender = <S01P00 reveal={deckRef.current} />;
      break;
    case "S01P02":
      ComponentToRender = <S01P02 reveal={deckRef.current} />;
      break;
    case "S02P01":
      ComponentToRender = <S02P01 reveal={deckRef.current} />;
      break;
    case "S02P02":
      ComponentToRender = <S02P02 reveal={deckRef.current} />;
      break;
    case "S03P01":
      ComponentToRender = <S03P01 reveal={deckRef.current} />;
      break;
    case "S03P02":
      ComponentToRender = <S03P02 reveal={deckRef.current} />;
      break;
    case "S04P01":
      ComponentToRender = <S04P01 reveal={deckRef.current} />;
      break;
    case "S05P01":
      ComponentToRender = <S05P01 reveal={deckRef.current} />;
      break;
    case "S05P02":
      ComponentToRender = <S05P02 reveal={deckRef.current} />;
      break;
    case "S06P01":
      ComponentToRender = <S06P01 reveal={deckRef.current} />;
      break;
    case "S07P01":
      ComponentToRender = <S07P01 reveal={deckRef.current} />;
      break;
    case "S08P01":
      ComponentToRender = <S08P01 reveal={deckRef.current} />;
      break;
    case "S09P01":
      ComponentToRender = <S09P01 reveal={deckRef.current} />;
      break;
    case "S11P01":
      ComponentToRender = <S11P01 reveal={deckRef.current} />;
      break;
    case "S12P01":
      ComponentToRender = <S12P01 reveal={deckRef.current} />;
      break;
    case "S14P01":
      ComponentToRender = <S14P01 reveal={deckRef.current} />;
      break;
    case "S15P01":
      ComponentToRender = <S15P01 reveal={deckRef.current} />;
      break;
    case "S16P01":
      ComponentToRender = <S16P01 reveal={deckRef.current} />;
      break;
    default:
      ComponentToRender = <div>Presentation not found</div>;
      break;
  }

  useEffect(() => {
    // Prevents double initialization in strict mode
    if (deckRef.current) return;

    deckRef.current = new Reveal(deckDivRef.current!, {
      hash: true,
      embedded: true,
      plugins: [Highlight, RevealNotes],
    });

    deckRef.current.initialize().then((deck) => {
      // good place for event handlers and plugin setups
    });

    return () => {
      try {
        if (deckRef.current) {
          deckRef.current.destroy();
          deckRef.current = null;
        }
      } catch (e) {
        console.warn("Reveal.js destroy call failed.");
      }
    };
  }, []);

  return (
    // Your presentation is sized based on the width and height of
    // our parent element. Make sure the parent is not 0-height.
    <div className="reveal" ref={deckDivRef}>
      <div className="slides">
        {/* { slides.map((slide) => {
          if (slide.children?.length) {
            return <section key={slide.id}><Slide {...slide} />{slide.children.map((subSlide) => <Slide key={subSlide.id} {...subSlide} />)}</section>
          } else {
            return <Slide key={slide.id} {...slide} />;
          }
        })} */}
        {ComponentToRender}
      </div>
    </div>
  );
}
